import React, { useContext, useEffect, useState } from "react";
import { FirebaseContext } from "../admin/context/FirebaseContext";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate, Outlet } from "react-router-dom";
import Header from "../admin/components/Header.component";
import SideBar from "../admin/components/SideBar.component";
import Spinner from "../Components/spinner.component";
import "../admin/styles/section.style.scss";
import "../admin/styles/main.css";

function ProtectedRoutes() {
  const navigate = useNavigate();
  const { auth } = useContext(FirebaseContext);
  const [loading, setLoading] = useState(true);
  const [openSideBar, setOpenSideBar] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        setTimeout(() => {
          navigate("/login", {
            replace: true,
          });
        }, 2000);
      } else {
        setLoading(false);
      }
    });
  });
  if (loading) {
    return <Spinner />;
  }
  return (
    <>
      <Header setToggleSideBar={setOpenSideBar} toggleSideBar={openSideBar} />
      <main className="ctn-content flex">
        <SideBar openSideBar={openSideBar} setOpenSideBar={setOpenSideBar} />
        <section className="main max-md:p-0">
          <Outlet />
        </section>
      </main>
      <div
        className={`backdrop__menu ${openSideBar ? "open" : "close"}`}
        onClick={() => setOpenSideBar(false)}
      ></div>
    </>
  );
}

export default ProtectedRoutes;
